import React from 'react';
import withRouter from '../../Components/Common/withRouter';
import { CRAFTED_BY_SHIVINFOTECH} from 'Components/constants/commonNames';

const ParticlesAuth = ({ children } : any) => {
    return (
        <React.Fragment>
            <div className="auth-page-wrapper pt-5">


                {children}

                <footer className="footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="text-center">
                                    <p className="mb-0 text-muted">&copy; {new Date().getFullYear()} {CRAFTED_BY_SHIVINFOTECH}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </React.Fragment>
    );
};

export default withRouter(ParticlesAuth);